export default __webpack_public_path__ + "static/media/vedantu.bf928fec.png";